module.exports = __webpack_public_path__ + "static/media/more-actions-gray.62371002.svg";